import api from './client'
import { descargarArchivo } from '../utils/descargar'
import { colors } from '../design/tokens'

export const informesEventoApi = {
  listar: (params = {}) => api.get('/informes-evento', { params }),
  // Eventos EVT para arrancar un informe (con sus facturas)
  eventos: (q = '') => api.get('/informes-evento/eventos', { params: { q: q || undefined } }),
  obtener: (id) => api.get(`/informes-evento/${id}`),
  crear: (articuloId) => api.post('/informes-evento', { articulo_id: articuloId }),
  actualizar: (id, data) => api.put(`/informes-evento/${id}`, data),
  eliminar: (id) => api.delete(`/informes-evento/${id}`),
  sincronizar: (id) => api.post(`/informes-evento/${id}/sincronizar`),
  // Facturas: traer una a mano (nº de factura o de NV), sacar, volver a incluir
  agregarFactura: (id, numero) => api.post(`/informes-evento/${id}/facturas`, { numero }),
  quitarFactura: (id, nvId) => api.delete(`/informes-evento/${id}/facturas/${nvId}`),
  incluirFactura: (id, nvId) => api.post(`/informes-evento/${id}/facturas/${nvId}/incluir`),
  // Vista previa en vivo: la cuenta vive en el backend (InformeEventoService)
  calcular: (id, data) => api.post(`/informes-evento/${id}/calcular`, data),
  cerrar: (id) => api.post(`/informes-evento/${id}/cerrar`),
  reabrir: (id) => api.post(`/informes-evento/${id}/reabrir`),
  // Etapa 3: LGR arma la NV de compensación (borrador, lista para enviar a Presea)
  compensacion: (id) => api.post(`/informes-evento/${id}/compensacion`),
  exportar: (informe, formato) => {
    const slug = (informe.nombre || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9]+/g, '_').replace(/^_|_$/g, '')
    return descargarArchivo(`/informes-evento/${informe.id}/exportar/${formato}`, `informe_${informe.numero}${slug ? `_${slug}` : ''}.${formato}`)
  },
}

// Estados del circuito (la regla vive en el backend; acá solo cómo se pintan)
export const ESTADOS_INFORME = {
  abierto: { label: 'Abierto', bg: colors.infoBg, color: colors.info },
  cerrado: { label: 'Cerrado', bg: colors.warnBg, color: colors.warn },
  completo: { label: 'Completo', bg: colors.okBg, color: colors.ok },
}
